import { staticTableCellFormatter, transformTableData } from 'Shared/components';
import { MODEL_DEFINITIONS, MODEL_DEFINITIONS_WES_WGS } from 'Common/consts/modelDefinitions';
import { createDefinitionModel, createTypeWithDescription, createDefinitionModelWithSeparatedLists, createModelWithDescription, } from 'ModelDefinitionsView/factories';
import { modelColumnFormatter } from 'ModelDefinitionsView/formatters';
import { ModelDefinitionsDataset } from 'ModelDefinitionsView/types';
import { ETableColumnAccessor } from '../types';
import styles from '../Page.css';
const TABLE_COLUMNS = [
    {
        Header: 'Model type',
        accessor: ETableColumnAccessor.Type,
        width: 165,
        className: styles.noHover,
        Cell: staticTableCellFormatter,
    },
    {
        Header: 'Model',
        accessor: ETableColumnAccessor.Model,
        width: 165,
        Cell: modelColumnFormatter,
    },
    {
        Header: 'Definition',
        accessor: ETableColumnAccessor.Definition,
        Cell: createDefinitionModel,
    },
];
const TABLE_COLUMNS_WES_WGS = [
    {
        Header: 'Model type',
        accessor: ETableColumnAccessor.Type,
        width: 165,
        className: styles.noHover,
        Cell: createTypeWithDescription,
    },
    {
        Header: 'Model',
        accessor: ETableColumnAccessor.Model,
        width: 165,
        Cell: createModelWithDescription,
    },
    {
        Header: 'Definition',
        accessor: ETableColumnAccessor.Definition,
        Cell: createDefinitionModelWithSeparatedLists,
    },
];
const TABLE_DATA = MODEL_DEFINITIONS;
const TABLE_DATA_WES_WGS = MODEL_DEFINITIONS_WES_WGS;
export const getColumns = (selectedDataset) => {
    if (selectedDataset === ModelDefinitionsDataset.WES_WGS) {
        return TABLE_COLUMNS_WES_WGS;
    }
    return TABLE_COLUMNS;
};
export const getTableData = (selectedDataset) => {
    if (selectedDataset === ModelDefinitionsDataset.WES_WGS) {
        return transformTableData(TABLE_DATA_WES_WGS);
    }
    return transformTableData(TABLE_DATA);
};
